import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/ship-from-storage-services.jpg'),
    alt: 'ship from storage services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'ship from storage services page search image',
    width: 92,
    height: 92
  }
]

export const heroSectionContent = {
  title: 'Fast <span>Ship</span><span>From Storage Services Near You</span>',
  description:
    'Experience the convenience and affordability of Ship from Storage Services with ShipAndStorage—your trusted partner offering secure, flexible shipping solutions that are expertly tailored to meet your unique needs and provide exceptional value for your storage requirements.',
  points: [
    'Affordable shipping rates',
    'Secure storage solutions',
    'Flexible service plans',
    'Reliable customer support'
  ],
  image: {
    url: '/images/v2/pages/landing-pages/ship-from-storage-services/hero-image.svg',
    alt: 'ship from storage services page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Get A Quote' }
}

export const helperGuideSection = {
  title: 'How ShipAndStorage Works',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.HOW_SHIP_AND_STORAGE_WORKS.href, text: 'Learn More' },

  cards: [
    {
      id: 1,
      title: 'Select Your Storage Option',
      description:
        'At ShipAndStorage, choosing the right storage option is effortless. We offer various solutions to ensure your belongings are stored securely and efficiently. Whether you need short-term or long-term storage, our range of options fits any requirement.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/select-your-storage-option.svg',
        alt: 'Select Your Storage Option service'
      }
    },
    {
      id: 2,
      title: 'Schedule Your Shipping',
      description:
        'Once your storage option is selected, scheduling your shipping is seamless. With our flexible shipping arrangements, you can choose the most convenient time for your items to be shipped from storage, accommodating your busy lifestyle and preferences.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/schedule-your-shipping.svg',
        alt: 'Schedule Your Shipping service'
      }
    },
    {
      id: 3,
      title: 'Enjoy Peace of Mind',
      description:
        'Relax knowing your belongings are in safe hands. With comprehensive tracking and exceptional customer support, you can monitor your items throughout the shipping process, providing peace of mind as you transition to your next destination.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/enjoy-peace-of-mind.svg',
        alt: 'Enjoy Peace of Mind service'
      }
    }
  ]
}

export const evenOddList = {
  title: 'Our Different Storage Services That You May Need',

  articles: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Our business storage solutions cater to companies requiring extra space for inventory, equipment, or documents. With secure access and flexible plans, businesses can effectively manage their resources without the overhead of additional office space.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/business-storage-solution.svg',
        alt: 'Business Storage Solution'
      },
      link: {
        text: 'Explore Business Storage',
        href: PUBLIC_MAIN_ROUTES.BUSINESS_STORAGE.href
      }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Transitioning to a new home? Our moving storage services are perfect for those in the midst of relocation. Store your belongings temporarily while you settle in, ensuring a seamless moving experience without the rush or stress.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/moving-storage-solution.svg',
        alt: 'Moving Storage Solution'
      },
      link: {
        text: 'Explore Moving Storage',
        href: PUBLIC_MAIN_ROUTES.MOVING_STORAGE_SOLUTIONS.href
      }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'Travel with ease using our luggage and box shipping services. We ensure your items reach their destination safely and promptly, allowing you to focus on your journey rather than worrying about transporting your belongings.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/luggage-and-box-shipping-services.svg',
        alt: 'Luggage and Box Shipping Services'
      },
      link: {
        text: 'Explore Luggage & Box Shipping',
        href: PUBLIC_MAIN_ROUTES.LUGGAGE_BOX_SHIPPING_SERVICES.href
      }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Homeowners will find our residential storage services ideal for managing space. Whether storing seasonal items, old furniture, or personal belongings, we provide safe, accessible solutions to meet all your storage needs.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/residential-storage-services.svg',
        alt: 'Residential Storage Services'
      },
      link: {
        text: 'Explore Residential Storage',
        href: PUBLIC_MAIN_ROUTES.RESIDENTIAL_STORAGE.href
      }
    }
  ]
}

export const gridSectionContent = {
  title: 'Who Chooses ShipAndStorage Service',

  cards: [
    {
      id: 1,
      title: 'College Students',
      description:
        'Our services are perfect for college students needing storage during summer breaks. Store your belongings safely until the next semester, allowing for a hassle-free transition between academic years.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/college-students.svg',
        alt: 'College Students'
      }
    },
    {
      id: 2,
      title: 'Relocating Families',
      description:
        'Families moving to new homes benefit from our flexible storage options. Store items temporarily during the transition, making the moving process smoother and less overwhelming.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/relocating-families.svg',
        alt: 'Relocating Families'
      }
    },
    {
      id: 3,
      title: 'Small Business Owners',
      description:
        'Small business owners often seek additional space for inventory and supplies. Our storage solutions provide cost-effective management options, enabling businesses to operate efficiently.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/small-business-owners.svg',
        alt: 'Small Business Owners'
      }
    },
    {
      id: 4,
      title: 'Travel Enthusiasts',
      description:
        'Frequent travelers appreciate our luggage shipping services, ensuring that their bags are shipped directly to their destinations, allowing them to travel light and worry-free.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/travel-enthusiasts.svg',
        alt: 'Travel Enthusiasts'
      }
    },
    {
      id: 5,
      title: 'Event Planners',
      description:
        'Event planners utilize our storage services to securely store decorations and supplies until needed. This facilitates better organization and planning, making every event a success.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/event-planners.svg',
        alt: 'Event Planners'
      }
    },
    {
      id: 6,
      title: 'Home Renovators',
      description:
        'Homeowners undergoing renovations find our storage solutions invaluable. Keep furniture and belongings safe during construction, protecting them from damage and ensuring a clean workspace.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/home-renovators.svg',
        alt: 'Home Renovators'
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Storage Service Is Necessary?',
  description: '',
  cards: [
    {
      id: 1,
      title: 'Space Optimization',
      description:
        'Utilizing storage services is essential for optimizing your available space. Whether you’re downsizing, decluttering, or simply need more room, our ship from storage services allow you to manage your belongings efficiently, keeping your living or working area organized and comfortable.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/space-optimization.svg',
        alt: 'Space Optimization'
      }
    },
    {
      id: 2,
      title: 'Secure Protection',
      description:
        'The security of your items is our top priority. Our secure storage solutions protect your belongings from damage, theft, and environmental factors. With advanced security measures in place, you can trust that your items will remain in excellent condition until you need them.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/secure-protection.svg',
        alt: 'Secure Protection'
      }
    },
    {
      id: 3,
      title: 'Convenient Access',
      description:
        "Having a reliable storage solution means easy access to your items whenever you need them. Whether it's seasonal decorations or essential business equipment, our storage services allow for quick retrieval, making transitions smoother and more manageable.",
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/convenient-access.svg',
        alt: 'Convenient Access'
      }
    }
  ]
}

export const whyChooseUsSectionContent2 = {
  title: 'Why Choose ShipAndStorage for Ship To Self Storage Services',

  cards: [
    {
      id: 1,
      title: 'Affordable Rates',
      description:
        'Enjoy competitive pricing designed to fit your budget without sacrificing quality. Our affordable rates make it easier to access top-notch storage and shipping services.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/affordable-rates.svg',
        alt: 'Affordable Rates'
      }
    },
    {
      id: 2,
      title: 'Reliable Service',
      description:
        'Count on our secure and dependable services. We prioritize the safety of your items, ensuring they are always accessible and well cared for.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/reliable-service.svg',
        alt: 'Reliable Service'
      }
    },
    {
      id: 3,
      title: 'Flexible Solutions',
      description:
        'Tailored plans cater to your individual needs. Our customizable options ensure you receive the best storage and shipping solutions suited to your requirements.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-from-storage-services/flexible-solutions.svg',
        alt: 'Flexible Solutions'
      }
    }
  ]
}

export const infoBannerSectionContent = {
  id: 1,
  title: 'Ship From Storage Services Near You Fast And Reliable',
  description:
    'Fast ship from storage services available near you. Affordable, reliable, and secure solutions for shipping your items from storage.',
  image: {
    src: '/images/v2/pages/landing-pages/ship-from-storage-services/ship-from-storage-services-near-you-fast-and-reliable.svg',
    alt: 'Ship From Storage Services Near You Fast And Reliable'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started' }
}

export const faqSectionContent = {
  title: 'Our Shipping Partners',
  description:
    'ShipAndStorage offers world-class Shipping and Storage Services in collaboration with trusted global carriers like FedEx, DHL, and UPS.',

  questions: [
    {
      id: 1,
      question: 'FedEx',
      answer:
        'Founded by Frederick W. Smith in 1971, FedEx started with just 186 packages and has since grown into a global leader in shipping services. Today, FedEx operates a vast fleet of 696 aircraft and 215,000 vehicles, processing 16 million shipments daily to over 220 countries and territories. With more than 550,000 employees and over 5,000 centers worldwide, FedEx ensures reliable and timely deliveries.|||Disclaimer|||This page was last updated in September 2024 for reference purposes only. FedEx makes no warranties, express or implied, regarding the accuracy or completeness of the information provided.|||For more details, visit FedEx.com. FedEx® is a registered trademark. © 1995-2024 FedEx. '
    },

    {
      id: 2,
      question: 'DHL',
      answer:
        'DHL Express, a major division of Deutsche Post DHL Group, is renowned for its international courier, parcel, and express mail services. As a global leader in logistics, DHL handles over 1.8 billion parcels annually. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became fully owned by Deutsche Post in 2002 and now operates in over 220 countries, playing a vital role in the global supply chain.|||Disclaimer:|||Disclaimer:|||Information updated as of September 2024 for reference purposes only. DHL makes no warranty regarding the accuracy of this information.|||For more details, visit DHL.com. DHL® is a registered trademark of DHL International GmbH. All rights reserved.'
    },
    {
      id: 3,
      question: 'UPS',
      answer:
        'UPS, initially founded in 1907 as the American Messenger Company by Claude Ryan and Jim Casey, became United Parcel Service (UPS) in 1919. Now among the largest global carriers, UPS delivers 25 million packages daily and reaches over 220 countries and territories. Supported by 500,000+ employees worldwide, UPS offers unmatched reach and reliability.|||Disclaimer:|||This page was last updated in September 2024 for reference purposes only. UPS makes no warranties regarding the accuracy of the information provided.|||For more details, visit UPS.com. UPS® is a registered trademark of UPS Inc. All rights reserved.'
    }
  ]
}
